(function () {
    var FACTORY_PREFIX = 'notificationFactory:';

    // region: Registration

    angular.module('tradersyard').factory('NativeNotificationParamsService', NativeNotificationParamsServiceFactory);

    // endregion

    // region: Implementation

    NativeNotificationParamsServiceFactory.$inject = ['$q', '$injector'];

    function NativeNotificationParamsServiceFactory($q, $injector) {
        return {
            getParams: getParams,
            hasFactory: hasFactory,
        };

        // region: Public Members

        /**
         * @param {NotificationData} notificationData
         * @returns {Promise<object>}
         */
        function getParams(notificationData) {
            var paramsFactory = getFactory(notificationData);

            if (!paramsFactory) {
                return $q.reject('Factory not registered. Notification params could not be returned.');
            }

            return $q.resolve(paramsFactory(notificationData));
        }

        /**
         * @param {NotificationData} notificationData
         * @returns {boolean}
         */
        function hasFactory(notificationData) {
            return !!getFactory(notificationData);
        }

        // endregion

        function getFactory(notificationData) {
            var notificationTag = buildNotificationTag(notificationData);
            var factoryName = FACTORY_PREFIX + notificationTag;

            if (!$injector.has(factoryName)) {
                console.warn('Notification factory for type `%s` not registered.', notificationTag);
                return undefined;
            }

            return $injector.get(factoryName);
        }

        /**
         * @param {NotificationData} notificationData
         * @returns {string}
         */
        function buildNotificationTag(notificationData) {
            return [notificationData.verb.name, notificationData.object.name].join('.');
        }
    }

    // endregion
})();
